<template>
    <!--    <svg-->
    <!--        class="h-[1.25em] animate-spinner-spin stroke-current"-->
    <!--        viewBox="0 0 50 50"-->
    <!--        aria-hidden="true"-->
    <!--        focusable="false"-->
    <!--        role="img"-->
    <!--        xmlns="http://www.w3.org/2000/svg"-->
    <!--    >-->
    <!--        <circle-->
    <!--            class="animate-spinner-dash"-->
    <!--            style="stroke-linecap: round"-->
    <!--            cx="25"-->
    <!--            cy="25"-->
    <!--            r="20"-->
    <!--            fill="none"-->
    <!--            stroke-width="8"-->
    <!--        ></circle>-->
    <!--    </svg>-->
    <span class="spinner"></span>
</template>
